exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description[data-v-047b84fe] {\n  width: 400px;\n  display: block;\n  word-break: break-word;\n}\n", ""]);

// exports
